import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 32px;
  margin-top: 20px;
  margin-bottom: 15px;
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #161d1f;
`;

const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;

const WrapperMessage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  width: 100%;
  flex: none;
  order: 1;
  flex-grow: 0;
  word-break: break-word;
`;

const CardLabels = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const CardCanceled = styled.div`
  background: #d5e5f0;
  border-radius: 24px;
  padding: 4px 12px;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #8090bb;
`;

export { Container, Title, Block, WrapperMessage, CardLabels, CardCanceled };
